import { createAsyncThunk } from "@reduxjs/toolkit";
import { ColumnFiltersState } from "@tanstack/react-table";
import { Axios } from "api/axios";
import { InventoryAxios } from "api/InventoryAxios";
import axios from "axios";

// export interface District {
//   id?: string;
//   packageName: string;
//   districtCode: string;
//   districtName: string;
//   state: string;
//   status: boolean;
//   createBy?: string;
//   updatedBy?: string;
//   createDate?: string;
//   updateDate?: string;
// }
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchRecordLevelWarehouseWise = createAsyncThunk(
  "inventory/fetchRecordLevelWarehouseWise",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      if (filters && filters.length > 0) {
        filters.forEach(
          ({
            filterField,
            filterValue,
          }: {
            filterField: string;
            filterValue: any;
          }) => {
            if (
              filterField &&
              filterValue !== undefined &&
              filterValue !== null
            ) {
              if (typeof filterValue === "object" && filterValue !== null) {
                Object.entries(filterValue).forEach(([key, value]) => {
                  if (value !== undefined && value !== null && value !== "") {
                    params.append(key, String(value));
                  }
                });
              } else {
                params.append(filterField, filterValue);
              }
            }
          }
        );
      }

      const response: any = await InventoryAxios.get(
        `/api/reorder-level/warehouse-items/`
      );

      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0,
      };
    } catch (error: any) {
      console.error(
        "fetch Inventory List error:",
        error.response?.data || error.message
      );
      throw new Error("Network Error");
    }
  }
);

export const exportCSVStockOverView = createAsyncThunk(
  "suppliers/exportCSVStockOverView",
  async (
    {
      filters,
    }: {
      filters?: ColumnFiltersState;
    },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("authToken");
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        Accept: "*/*",
      };

      const params: Record<string, any> = {
        export: "csv",
      };

      if (filters && Array.isArray(filters)) {
        filters.forEach(({ id, value }) => {
          if (!id || value === undefined || value === "") return;

          if (
            (id === "updated_at" || id === "created_at") &&
            typeof value === "object" &&
            value !== null
          ) {
            const { from_date, to_date } = value as {
              from_date?: string;
              to_date?: string;
            };
            if (from_date) params["from_date"] = from_date;
            if (to_date) params["to_date"] = to_date;
            params["filter_by"] = id;
          } else if (
            typeof value === "object" &&
            value !== null &&
            (value as Record<string, any>)[id]
          ) {
            params[id] = (value as Record<string, any>)[id];
          } else {
            params[id] = value;
          }
        });
      }

      const response = await InventoryAxios.get(
        "/in-stock/export/stock-overview/",
        {
          headers,
          params,
          responseType: "blob",
        }
      );

      return {
        blob: response.data,
        filename:
          response.headers["content-disposition"]
            ?.split("filename=")[1]
            ?.replace(/"/g, "") || "Approved PR.csv",
      };
    } catch (err: any) {
      return rejectWithValue(err.message || "Failed to export CSV");
    }
  }
);
